var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppareilPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.3703 43.75H29.6295C36.1318 43.75 39.3829 43.75 41.7183 42.2179C42.7291 41.5546 43.5972 40.7023 44.2729 39.7098C45.8333 37.4169 45.8333 34.2248 45.8333 27.8408C45.8333 21.4571 45.8333 18.265 44.2729 15.9721C43.5972 14.9795 42.7291 14.1272 41.7183 13.4639C40.2175 12.4794 38.3389 12.1276 35.4625 12.0018C34.0897 12.0018 32.9081 10.9806 32.6389 9.65908C32.235 7.67685 30.4623 6.25 28.4035 6.25H21.5964C19.5376 6.25 17.7649 7.67685 17.3611 9.65908C17.0919 10.9806 15.9101 12.0018 14.5375 12.0018C11.6611 12.1276 9.78235 12.4794 8.28171 13.4639C7.27069 14.1272 6.40263 14.9795 5.72708 15.9721C4.16663 18.265 4.16663 21.4571 4.16663 27.8408C4.16663 34.2248 4.16663 37.4169 5.72708 39.7098C6.40263 40.7023 7.27069 41.5546 8.28171 42.2179C10.6171 43.75 13.8682 43.75 20.3703 43.75Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5754 19.3176C35.6166 19.3176 34.8394 20.0808 34.8394 21.0221C34.8394 21.9635 35.6166 22.7267 36.5754 22.7267H38.8902C39.8491 22.7267 40.6264 21.9635 40.6264 21.0221C40.6264 20.0808 39.8491 19.3176 38.8902 19.3176H36.5754Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0015 19.3176C20.2072 19.3176 16.3208 23.1333 16.3208 27.8404C16.3208 32.5473 20.2072 36.3631 25.0015 36.3631C29.7954 36.3631 33.6819 32.5473 33.6819 27.8404C33.6819 23.1333 29.7954 19.3176 25.0015 19.3176ZM25.0015 22.7267C22.1248 22.7267 19.793 25.0163 19.793 27.8404C19.793 30.6646 22.1248 32.954 25.0015 32.954C27.8779 32.954 30.2098 30.6646 30.2098 27.8404C30.2098 25.0163 27.8779 22.7267 25.0015 22.7267Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppareilPhoto);
export default __webpack_public_path__ + "static/media/appareil_photo.ab23198e87c1c3fd9d3a89cff0e4caef.svg";
export { ForwardRef as ReactComponent };